import React from "react";

var mobileDevice = "";
var playstore = "";

const Refer = () => {
  const [referCode, setReferCode] = React.useState();

  React.useEffect(() => {
    // console.log(
    //   "window.location.hostname :::",
    //   window.location.pathname,
    //   window.location.pathname.split("/")
    // );

    const refer = window.location.search;
    const refer1 = refer.split("=")[1];
    // console.log("refer ...", refer1);
    setReferCode(refer1);

    // var userAgent = navigator.userAgent.toLowerCase();
    // var Android = userAgent.indexOf("android") > -1;

    // if (Android) {
    //   res = "Device is Android Phone";
    // }
    // el_down.innerHTML = res;
  }, []);

  // check device
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    console.log("window...");
    mobileDevice = "window";
    // return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    console.log("android...");
    mobileDevice = "android";
    // return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    mobileDevice = "ios";
    // return "iOS";
  }
  // end check device

  var appurl = `unitydl://wolfwingames?refer=${referCode}`;

  console.log("mobileDevice...", mobileDevice);
  if (mobileDevice === "android") {
    playstore = "https://play.google.com/store/apps/details?id=com.wolfwin";
  } else if (mobileDevice === "ios") {
    playstore = "https://www.google.com/";
  } else {
    playstore = "https://play.google.com/store/apps/details?id=com.wolfwin";
  }

  // console.log("appurl...", appurl);
  // console.log("playstore...", playstore);

  // window.onload = function () {
  //   startApp();
  // };

  setTimeout(() => {
    startApp();
  }, 10);

  var timeout;
  const preventPopup = () => {
    clearTimeout(timeout);
    timeout = null;
    window.removeEventListener("pagehide", preventPopup);
  };

  const startApp = () => {
    window.location = appurl;
    timeout = setTimeout(function () {
      document.location = playstore;
      // window.open = appstore
    }, 100);
    window.addEventListener("pagehide", preventPopup);
  };

  return <div></div>;
};

export default Refer;
